export enum SettingsPathList {
	settings = '/settings',
	surveyTracking = '/tracking',
	roundScheduling = '/round/edit',
	emailsEdit = '/edit/emails',
}
